import C, { getCountryCallingCode as I } from './contact-channels79.js';
import r from './contact-channels213.js';
import m from './contact-channels231.js';
import l from './contact-channels186.js';

function x(n,i,e,r$1){var o=i?I(i,r$1):e;if(n.indexOf(o)===0){r$1=new C(r$1),r$1.selectNumberingPlan(i,e);var t=n.slice(o.length),C$1=m(t,r$1),g=C$1.nationalNumber,N=m(n,r$1),l$1=N.nationalNumber;if(!r(l$1,r$1.nationalNumberPattern())&&r(g,r$1.nationalNumberPattern())||l(l$1,r$1)==="TOO_LONG")return {countryCallingCode:o,number:t}}return {number:n}}

export { x as default };
//# sourceMappingURL=contact-channels215.js.map
